import { ReactElement } from 'react';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import { Draw, DrawMap, DrawOptions } from 'leaflet';
import 'leaflet-arrowheads';
import { DrawShapeControl } from '..';
import { MapViewerPanel } from '../../../redux';
import { PolylineDrawOverwrite } from '../../../utils';
import { useTranslation } from 'react-i18next';

export function DrawArrowControl(): ReactElement {
	const { t } = useTranslation('map');

	function createArrowFeature(map: DrawMap): Draw.Feature {
		const options: DrawOptions.PolylineOptions = {
			shapeOptions: {
				color: '#000000',
				dashArray: ''
			},
			maxPoints: 2
		};
		return new PolylineDrawOverwrite(map, options);
	}

	return (
		<DrawShapeControl
			controlPanel={MapViewerPanel.DrawArrow}
			tooltip={t('actionButtons.edit.arrow')}
			icon={<ArrowRightAltIcon />}
			createFeature={createArrowFeature}
		></DrawShapeControl>
	);
}
